import { PageOpts, XandrData } from '../../shared/types/ast';
import { getGlimrKeywords } from './glimr';
import { setExternalUid } from './external-id';
import { getConfig } from '../config';

/**
 * Currently used for recirc placements. Not ready for Travel pages because enableNRM is removed completely from this logic.
 * The logic in this function is picked from client/index.ts but has removed enableNRM completely.
 * It is counted as true always. That is why it's not Travel-ready, cause travel sends enableNRM false from our podlet node backend.
 */
export function setupPageOptsAndGetXandrData(): PageOpts {
    const config = getConfig();

    const xandr = config.xandr as XandrData;

    if (xandr) {
        const preKeywords = xandr?.pageOpts?.keywords;
        const glimrKeywords = getGlimrKeywords();
        if (preKeywords) {
            xandr.pageOpts.keywords = {
                ...preKeywords,
                ...glimrKeywords,
            };
        } else {
            xandr.pageOpts.keywords = {
                ...glimrKeywords,
            };
        }
    }

    const pageOptsWithUserIds = setExternalUid(xandr?.pageOpts || {});
    return { ...xandr, ...pageOptsWithUserIds };
}

export const getKeywordByKey = (key: string): string[] | undefined => {
    const config = getConfig();
    const { keywords } = config?.xandr?.pageOpts;
    if (keywords) {
        return keywords[key];
    } else return undefined;
};
